/**
 * Affectations et saisie des notes (TODO phase 14, ADR-031).
 * Contrôles partagés API ↔ portail : la grille de saisie signale les mêmes
 * erreurs que le serveur, qui reste seul juge.
 */
import { aggregateCorrections, roundTo, scorePerformance, } from './selection.js';
export const SHEET_STATUSES = {
    draft: 'En saisie',
    submitted: 'Soumis',
    validated: 'Validé',
    unlocked: 'Rouvert',
};
export const MARK_STATUSES = {
    present: 'Présent',
    absent: 'Absent',
    exempt: 'Dispensé',
};
export const LOT_MODES = {
    alphabetical: 'Ordre alphabétique',
    random: 'Tirage aléatoire',
    application: 'Ordre des matricules',
};
const isMultiple = (value, base, step) => Math.abs(roundTo(value - base, step) - (value - base)) < 1e-9;
/**
 * Contrôle d'une saisie (cahier §9.5) : bornes, pas de saisie, statut connu.
 * `discipline` vaut `null` pour une étape non notée (statut d'étape).
 */
export function checkGrade(input, discipline, stageStatuses, gender) {
    const out = {
        status: input.status,
        value: null,
        performance: null,
        code: null,
        error: null,
    };
    if (input.status !== 'present')
        return out;
    const statuses = discipline ? (discipline.statuses ?? []) : stageStatuses;
    if (!discipline || discipline.grading === 'status') {
        const code = (input.code ?? '').trim();
        if (!code)
            out.error = 'Statut à choisir.';
        else if (!statuses.some((s) => s.code === code))
            out.error = 'Statut inconnu.';
        else
            out.code = code;
        return out;
    }
    if (discipline.grading === 'performance') {
        const p = input.performance;
        if (p === null || p === undefined || Number.isNaN(p)) {
            out.error = 'Performance manquante.';
            return out;
        }
        if (p < 0) {
            out.error = 'Performance négative.';
            return out;
        }
        out.performance = p;
        out.value = scorePerformance(discipline.scale, p, gender, discipline.minScore);
        return out;
    }
    const v = input.value;
    if (v === null || v === undefined || Number.isNaN(v)) {
        out.error = 'Note manquante.';
        return out;
    }
    if (v < discipline.minScore || v > discipline.maxScore) {
        out.error = `Note hors barème (${discipline.minScore} à ${discipline.maxScore}).`;
        return out;
    }
    if (!isMultiple(v, discipline.minScore, discipline.precision)) {
        out.error = `Pas de saisie : ${String(discipline.precision).replace('.', ',')}.`;
        return out;
    }
    out.value = v;
    return out;
}
/** Une ligne est-elle complète (prête à soumettre) ? */
export const isGradeComplete = (g) => g.status !== 'present' || g.value !== null || g.code !== null;
/**
 * Écarts entre correcteurs au-delà du seuil (`max_gap`) sans 3e correction :
 * à signaler à la commission (cahier §9.5).
 */
export function correctionGaps(discipline, byCandidate) {
    if (discipline.multiRule !== 'max_gap' || discipline.evaluators < 2)
        return [];
    const out = [];
    for (const [stageCandidateId, values] of Object.entries(byCandidate)) {
        if (values.length !== 2)
            continue;
        if (aggregateCorrections(values, discipline) === null)
            out.push({ stageCandidateId, values, gap: Math.abs(values[0] - values[1]) });
    }
    return out;
}
/** Valeur d'une cellule saisie au clavier : « 12,5 » → 12.5 ; vide → null. */
export function parseScore(text) {
    const t = text.trim().replace(/\s/g, '').replace(',', '.');
    if (!t)
        return null;
    if (!/^-?\d+(\.\d+)?$/.test(t))
        return Number.NaN;
    return Number(t);
}
/** Abréviations acceptées dans la grille et à l'import : ABS, DISP. */
export function parseCell(text) {
    const t = text.trim().toUpperCase();
    if (t === 'ABS' || t === 'A')
        return { status: 'absent' };
    if (t === 'DISP' || t === 'D')
        return { status: 'exempt' };
    return { status: 'present', value: parseScore(text) };
}
//# sourceMappingURL=grading.js.map